<template>
  <div class="feature-notification-container" v-if="innerVisible">
    <div class="feature-notification-content">
      <img class="img-bg" :src="featureNotificationBh" alt="">
      <img class="btn-close" :src="btnCloseImage" alt="" @click="handleCancel">
      <div class="btn-ok" @click="handleOK"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect } from "vue";
import { useUserStore } from '/@/store/modules/user';
import featureNotificationBh from '/@/assets/images/featureNotification/img-bg.png'
import btnCloseImage from '/@/assets/images/featureNotification/img-btn-close.png'
import { NEW_FEATURE_NOTIFICATION_KEY } from "/@/enums/cacheEnum";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:visible', 'handleOk']);

const innerVisible = ref(false);

const handleOK = () => {
  handleCancel();
  emit('handleOk');
};

const handleCancel = () => {
  const userStore = useUserStore();
  const userId = userStore.getUserInfo?.id;
  if (userId) {
    const storageKey = `${NEW_FEATURE_NOTIFICATION_KEY}${userId}`;
    localStorage.setItem(storageKey, 'true');
  }
  emit('update:visible', false);
};


watchEffect(() => {
  innerVisible.value = props.visible;
});
</script>

<style lang="less" scoped>
.feature-notification-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;

  .feature-notification-content {
    width: 751px;
    height: 533px;
    position: relative;
    .img-bg {
      width: 100%;
      height: 100%;
    }
    .btn-close {
      position: absolute;
      top: -50px;
      right: 100px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
    }

    .btn-ok {
      position: absolute;
      bottom: 0;
      left: 270px;
      width: 210px;
      height: 70px;
      border-radius: 70px;
      cursor: pointer;

    }
  }
}
</style>